import { getPublicLang } from 'academy-common-lib/utils/url';
import { socialLinks } from './footerLinks';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { appendHubsContent } from '../../../../utils/urls';
import { Flex } from 'foundations-components/components/Flex';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Link } from 'foundations-components/transitional/components/Link';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SocialLinks = () => {
  const {
    isNotTablet
  } = useMediaQuery('notTablet');
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "center",
    flexDirection: "row",
    gap: isNotTablet ? '100' : '400',
    justifyContent: isNotTablet ? 'space-between' : 'center',
    marginBlock: "600",
    children: socialLinks.map(link => {
      const linkHref = link.hrefs[getPublicLang()] || link.hrefs.en;
      if (!linkHref) return null;
      return /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsxs(Link, {
          href: appendHubsContent(linkHref, link.name),
          rel: "noopener noreferrer",
          target: "_blank",
          title: link.name,
          children: [/*#__PURE__*/_jsx(IconHolder, {
            "aria-label": link.name,
            color: "icon-core-disabled",
            icon: link.FoundationIcon,
            margin: "0",
            padding: "0",
            size: "600"
          }), /*#__PURE__*/_jsx(Paragraph, {
            display: "none",
            children: link.name
          })]
        })
      }, link.name);
    })
  });
};
export default SocialLinks;